<template>
  <el-col :span="24" :lg="lg">
    <div style="margin-bottom: 10px">
      <el-button
        type="primary"
        icon="el-icon-location"
        size="small"
        @click="getCurrentLocation"
        :loading="loading"
      >
        {{ loading ? 'Locating...' : 'Use My Location' }}
      </el-button>
      <el-input
        v-model.number="radius"
        type="number"
        placeholder="Enter Radius (meters)"
        style="width: 200px; margin-left: 10px"
        @input="updateCircleRadius"
      >
        <template #prefix>
          <el-icon><i class="el-icon-circle-check" /></el-icon>
        </template>
      </el-input>
    </div>

    <GoogleMap
      api-key="AIzaSyCnwdGnzLZgi--f7jbuqT9Iu22NTeFuOmo"
      style="height: 300px"
      :center="center"
      :zoom="zoom"
      @click="updateCenter"
    >
      <Marker :options="{ position: center, draggable: true }" @dragend="onMarkerDrag" />
      <Circle :options="circleOptions" />
    </GoogleMap>
  </el-col>
</template>

<script>
import { GoogleMap, Marker, Circle } from 'vue3-google-map'

export default {
  components: {
    GoogleMap,
    Marker,
    Circle
  },
  props: {
    modelValue: Object,
    label: String,
    lg: {
      type: String,
      default: '12'
    },
    disabled: Boolean
  },
  emits: ['update:modelValue'],
  data() {
    return {
      center: { lat: 11.5564, lng: 104.9282 },
      zoom: 16,
      loading: false,
      radius: 300,
    }
  },
  computed: {
    circleOptions() {
      return {
        center: this.center,
        radius: this.radius,
        strokeColor: '#FF0000',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#FF0000',
        fillOpacity: 0.2
      }
    }
  },
  mounted() {
  if (this.modelValue?.lat && this.modelValue?.lng) {
    this.center = { lat: this.modelValue.lat, lng: this.modelValue.lng }
    this.radius = this.modelValue.radius || 300
  } else {
    this.getCurrentLocation()
  }
},
watch: {
  modelValue: {
    handler(newVal) {
      if (newVal?.lat && newVal?.lng) {
        this.center = { lat: newVal.lat, lng: newVal.lng }
        this.radius = newVal.radius || 300
      }
    },
    deep: true,
    immediate: true
  }
},
  methods: {
    getCurrentLocation() {
      this.loading = true
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const { latitude, longitude } = pos.coords
          this.center = { lat: latitude, lng: longitude }
          this.emitUpdate()
          this.loading = false
        },
        (err) => {
          console.error('Geolocation failed:', err)
          this.loading = false
        }
      )
    },
    updateCenter(event) {
      this.center = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng()
      }
      this.emitUpdate()
    },
    onMarkerDrag(event) {
      this.center = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng()
      }
      this.emitUpdate()
    },
    updateCircleRadius() {
      this.emitUpdate()
    },
    emitUpdate() {
      this.$emit('update:modelValue', {
        ...this.modelValue, // preserve other fields like workingPlaceName
        lat: this.center.lat,
        lng: this.center.lng,
        radius: this.radius
      })
    }
  }
}
</script>
